var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatContainer"},[(_vm.src)?_c('iframe',{staticClass:"chat",attrs:{"src":_vm.src,"frameborder":"0"}}):_c('flixLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }